import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { paths } from '../../routes/paths';
import { cn } from '../../utils/cn';

/**
 * Atalho discreto para o espelho de gastos (página Despesas).
 */
export function BudgetSpendCycleLink({ className }) {
  return (
    <div className={cn('flex justify-center px-space-2 pb-space-1', className)}>
      <Link
        to={paths.expenses}
        className="type-body-sm inline-flex items-center gap-space-1 font-semibold text-sage-on-tint transition-colors hover:text-sage-700"
      >
        {pt.budget.spendCycleLink}
        <CaretRight className="h-3.5 w-3.5" aria-hidden />
      </Link>
    </div>
  );
}
